import dayjs from 'dayjs'
import React, { useState } from 'react'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import Responsive from '../assets/config/Responsive'
import CopyIcon from '../assets/icons/JSX/CopyIcon'
import TravelServiceIcon from '../assets/icons/JSX/TravelServiceIcon'
import WelcomerCategoryIcon from '../assets/icons/JSX/WelcomerCategoryIcon'
import PetCategoryIcon from '../assets/icons/JSX/PetCategoryIcon'
import TplCategoryIcon from '../assets/icons/JSX/TplCategoryIcon'
import Colors from '../assets/styles/Colors'
//
//
//
const HorizontalPendingPolicyCard: React.FC<{
  checkbox?: React.ReactNode
  companyName?: string
  insurerName?: string
  policyNumber?: string
  dateFrom?: string | Date
  dateTo?: string | Date
  style?: React.CSSProperties
  policyStatus?: string
  type?: string
  policyId?: number
  iconChildren?: React.ReactNode
  onClick?: () => void
}> = ({
  checkbox,
  companyName,
  insurerName,
  policyNumber,
  dateFrom,
  dateTo,
  style,
  policyStatus = true,
  type,
  policyId,
  iconChildren,
  onClick,
}) => {
  // for copy function
  const [copied, setCopied] = useState<boolean>(false)

  // copy policy numner
  const copyPolicyNumber = (e: any) => {
    e.stopPropagation()
    navigator.clipboard.writeText(e.currentTarget.innerText)
    setCopied(true)
    toast.success('დაკოპირდა')
    // for change color in copied text
    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  return (
    <>
      <Card onClick={onClick} style={style}>
        <Item>
          <span onClick={(event) => event.stopPropagation()}>{checkbox}</span>
        </Item>
        <Item>
          {/* <TravelServiceIcon /> */}
          {type?.toLowerCase() === 'travelpolicy' && <TravelServiceIcon />}
          {type?.toLowerCase() === 'welcomerpolicy' && <WelcomerCategoryIcon />}
          {type?.toLowerCase() === 'tplpolicy' && <TplCategoryIcon />}
          {type?.toLowerCase() === 'petpolicy' && <PetCategoryIcon />}
        </Item>
        <Item>
          <div>{String(type?.match(/[A-Z][a-z]+/g))?.replace(',', ' ')}</div>
          <div>{companyName}</div>
        </Item>
        <Item>
          <div>{insurerName}</div>
          <div>
            <span>Policy N:</span>
            <PolicyNumberSpan $copied={copied} onClick={(event) => copyPolicyNumber(event)}>
              {policyNumber} <CopyIcon />
            </PolicyNumberSpan>
          </div>
        </Item>
        <Item>
          <div>Start: {dayjs(dateFrom).format('DD.MM.YYYY')}</div>
          <div>End: {dayjs(dateTo).format('DD.MM.YYYY')}</div>
        </Item>
        <Item>
          <StatusDiv>
            {policyStatus}
            {policyStatus && (
              <StatusBall
                style={{
                  backgroundColor:
                    policyStatus === 'active'
                      ? Colors.java
                      : policyStatus === 'pending'
                      ? Colors.Primary
                      : Colors.primaryRed,
                }}
              />
            )}
          </StatusDiv>
        </Item>
        {iconChildren && <Item>{iconChildren}</Item>}
      </Card>

      <MobileCard onClick={onClick}>
        <ContentStylesMobile>
          <div>
            <Title>
              <span>
                <HeaderDiv>{String(type?.match(/[A-Z][a-z]+/g))?.replace(',', ' ')}</HeaderDiv>
                <div>{companyName}</div>
              </span>
            </Title>
            <Title>
              <>{checkbox}</>
            </Title>
          </div>
          <div>
            <Title>
              <span>
                <HeaderDiv>{insurerName}</HeaderDiv>
                <div>
                  <PolicyNumberSpan $copied={copied} onClick={(event) => copyPolicyNumber(event)}>
                    {policyNumber} <CopyIcon />
                  </PolicyNumberSpan>
                </div>
              </span>
            </Title>
            <Title>
              <MobileIcon>
                {/* <TravelServiceIcon /> */}
                {type?.toLowerCase() === 'travelpolicy' && <TravelServiceIcon />}
                {type?.toLowerCase() === 'welcomerpolicy' && <WelcomerCategoryIcon />}
                {type?.toLowerCase() === 'tplpolicy' && <TplCategoryIcon />}
                {type?.toLowerCase() === 'petpolicy' && <PetCategoryIcon />}
              </MobileIcon>
            </Title>
          </div>
          <hr />
          <div>
            <Title>
              <HeaderDiv>Start: {dayjs(dateFrom).format('DD.MM.YYYY')}</HeaderDiv>
            </Title>
            <Title>
              <MobileStatusDiv>
                {policyStatus}{' '}
                {policyStatus && (
                  <StatusBall
                    style={{
                      backgroundColor:
                        policyStatus === 'active'
                          ? Colors.java
                          : policyStatus === 'pending'
                          ? Colors.Primary
                          : Colors.primaryRed,
                    }}
                  />
                )}
              </MobileStatusDiv>
            </Title>
          </div>
          <br />
          <Buttons>
            <Title>{iconChildren}</Title>
          </Buttons>
        </ContentStylesMobile>
      </MobileCard>
    </>
  )
}
// <{ $copied: boolean }>
//  border-color: ${({ $copied }) => ($copied === true ? "green" : "transparent")};
//
const StatusDiv = styled.div`
  position: relative;
  text-transform: capitalize;
`
const StatusBall = styled.span`
  height: 5px;
  width: 5px;
  border-radius: 50px;
  background-color: ${Colors.primaryGreen};
  user-select: none;
  pointer-events: none;
  padding: 0px !important;
  position: absolute;
  /* right: -12px; */
  margin-left: 5px;
  top: 20px;
  ${Responsive.laptop} {
    right: unset;
    margin-left: 5px;
  }
  ${Responsive.mobile} {
    top: 8px;
    right: -10px;
  }
  ${Responsive.tablet} {
    top: 10px;
    right: -10px;
  }
`
const PolicyNumberSpan = styled.span<{ $copied: boolean }>`
  cursor: pointer;
  color: ${({ $copied }) => ($copied === true ? Colors.primaryGreen : Colors.primaryGrey)};
  ${Responsive.tablet} {
    margin-right: -5px;
  }
  ${Responsive.mobile} {
    margin-right: -5px;
  }
`
const Item = styled.div`
  font-size: 14px;
  color: ${Colors.primaryGrey};
  user-select: none;
  /* first div */
  span:first-of-type {
    padding: 0px;
  }
  div {
    &:first-of-type {
      color: ${Colors.primaryBlack};
    }
    /*copy icon  */
    span {
      padding: 5px;
      svg {
        cursor: pointer;
        height: 13px;
        margin-left: 5px;
        margin-top: -2px;
      }
    }
  }

  /* childres */
  &:nth-child(2) {
    width: 100px;
    display: flex;
    margin-left: 20px;
    svg {
      width: 100%;
    }
  }
  &:nth-child(3) {
    width: 220px;
    padding-left: 20px;
  }
  &:nth-child(4) {
    border-left: 1px solid ${Colors.secondaryGrey};
    padding-left: 30px;
    width: 250px;
  }
  &:nth-child(5) {
    border-left: 1px solid ${Colors.secondaryGrey};
    padding-left: 30px;
    padding-right: 10px;
  }
  &:nth-child(6) {
    border-left: 1px solid ${Colors.secondaryGrey};
    padding-left: 20px;
    padding-right: 20px;
    line-height: 42px;
  }
  &:nth-child(7) {
    border-left: 1px solid ${Colors.secondaryGrey};
    padding-left: 20px;
    line-height: 42px;
    display: flex;
    button {
      height: 40px;
    }
    svg {
      width: fit-content;
    }
  }

  /* current svg */
  svg {
    height: 63px;
    width: fit-content;
  }

  /* responsive */
  ${Responsive.laptop} {
    font-size: 12px;
    /* childres */
    &:nth-child(2) {
      width: 90px;
      margin-left: 0;
      svg {
        width: 100%;
      }
      padding-left: 0px;
    }
    &:nth-child(3) {
      width: 160px;
      margin-right: 5px;
      padding-left: 10px;
      padding-right: 5px;
      border-right: 1px solid ${Colors.secondaryGrey};
    }
    &:nth-child(4) {
      width: 160px;
      padding-left: 10px;
      padding-right: 10px;
      border-left: none;
    }
    &:nth-child(5) {
      padding: unset;
      padding-left: 20px;

      margin-right: 10px;
      border-left: 1px solid ${Colors.secondaryGrey};
    }
    &:nth-child(6) {
      padding-left: 10px;
      padding-right: 20px;
    }
    &:nth-child(7) {
      padding-left: 10px;
      display: flex;
      max-width: 180px;
      button:first-child {
        flex: 0 0 112px;
      }
    }
  }
`
const ContentStylesMobile = styled.div`
  display: none;
  ${Responsive.mobile} {
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid ${Colors.secondaryGrey};
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    button {
      height: 40px;
    }
    /*  */
    &:last-child {
      border: 0px;
      margin-bottom: 0px;
      padding-bottom: 10px;
    }
  }
  ${Responsive.tablet} {
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid ${Colors.secondaryGrey};
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    button {
      height: 40px;
    }
    /*  */
    &:last-child {
      border: 0px;
      margin-bottom: 0px;
      padding-bottom: 10px;
    }
  }
`
const HeaderDiv = styled.div`
  color: ${Colors.primaryBlack};
`
const Title = styled.div`
  font-size: 14px;
  color: ${Colors.primaryGrey};
  user-select: none;
  /* responsive */
  ${Responsive.mobile} {
    margin-left: 0;
    padding-left: 0;
    margin-top: 10px;
  }

  ${Responsive.mobile} {
    margin-left: 0;
    padding-left: 0;
    margin-top: 10px;
  }
`

const MobileCard = styled.div`
  display: none;
  border-radius: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
  -webkit-box-shadow: 0px 0px 15px 3px #88888811;
  box-shadow: 0px 0px 15px 3px #88888811;
  background-color: ${Colors.white};
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
  ${Responsive.mobile} {
    display: block;
    padding-inline: 24px;
  }
  ${Responsive.tablet} {
    display: block;
    padding-inline: 24px;
  }
`
const Card = styled.div`
  width: 100%;
  background-color: ${Colors.white};
  border-radius: 8px;
  -webkit-box-shadow: 0px 0px 15px 3px #88888811;
  box-shadow: 0px 0px 15px 3px #88888811;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 135px;
  padding-left: 40px;
  padding-right: 40px;
  margin-bottom: 32px;
  cursor: pointer;

  /* responsive */
  ${Responsive.laptop} {
    padding-left: 15px;
    padding-right: 15px;
  }
  ${Responsive.tablet} {
    flex-direction: column;
    justify-content: center;
    height: fit-content;
    padding: 30px 25px 10px;
    margin-bottom: 20px;
    overflow-x: hidden;
    display: none;
  }
  ${Responsive.mobile} {
    display: none;
  }
`
const MobileIcon = styled.div`
  display: none;
  ${Responsive.mobile} {
    display: block;
    width: 90px;
  }
  ${Responsive.tablet} {
    display: block;
    width: 90px;
  }
`
const MobileStatusDiv = styled.div`
  display: none;
  ${Responsive.mobile} {
    display: block;
    position: relative;
    text-transform: capitalize;
    margin-right: 15px;
  }
  ${Responsive.tablet} {
    display: block;
    position: relative;
    text-transform: capitalize;
    margin-right: 15px;
  }
`
const Buttons = styled.div`
  div {
    width: 100%;
  }
`

export default HorizontalPendingPolicyCard
